import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  /* Height comes from flex stretch (cross-axis of <main>), NOT height:100%.
     On mobile <main> is a column-flex child whose grown height a percentage
     won't resolve against, so height:100% collapsed this to content height and
     nothing scrolled. min-height:0 lets the inner scroller shrink below content. */
  min-height: 0;
  overflow: hidden;
`;

export type ContentProps = {
  children: ReactNode;
};

export const Content: FC<ContentProps> = ({ children }) => {
  return (
    <main>
      <ContentContainer>{children}</ContentContainer>
    </main>
  );
};
